import { Button, TextField } from "@mui/material";
import React, { useRef, useEffect, useState } from "react";
import { useReactToPrint } from "react-to-print";
import BarcodeGenerator from "../components/Barcode/BarcodeGenerator";
const Barcode = () => {
  const printLableRef = useRef();
  const [values, setValues] = useState({ barcode: "", barcodeCount: 0 });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };
  const printLabel = useReactToPrint({
    pageStyle: `  
    @media print{
      @page {
          margin-top: 20px;
          margin-bottom: 20px;
           }
      body{
          
          -webkit-print-color-adjust: exact;
      }
      section{
      
      background-color: white;
  }
  h1{
      font-size: 20px;
      
  }
  p{
      font-size: 16px;
  }
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => printLableRef.current,
  });

  const showBarcode = () => {
    let mapArray = [];
    let barcodeCount = values.barcode.split(",")
    
    if(!barcodeCount || barcodeCount.length === 0 ) return alert("Please enter barcode first")

    for (let i = 0; i < Number(barcodeCount.length ); i++) {
     
      for (let ii = 0; ii < Number(values.barcodeCount ); ii++) {

        mapArray.push(barcodeCount[i]);
      }
    }

    
    return (
      <>
        {Number(values.barcodeCount) === 0 ? (
          <div>Generate Barcode</div>
        ) : (
          (mapArray).map((x,i) => {
            
            return (
              <BarcodeGenerator key={i}  value={x}></BarcodeGenerator>
            )
          })
        )}
      </>
    );
  };
  
  return (
    <div className="flex flex-col ">
      <div className="flex">
        <TextField
          label="Enter Barcode"
          name="barcode"
          onChange={handleChange}
          value={values.barcode}
        ></TextField>
        <TextField
          label="Enter Barcode Amount"
          name="barcodeCount"
          onChange={handleChange}
          value={values.barcodeCount}
          type="number"
        ></TextField>

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={printLabel}
        >
          Print Label
        </Button>
      </div>
      <div ref={printLableRef} className="flex flex-wrap p-4 mt-4">
        {Number(values.barcodeCount) !== 0 && showBarcode()}
      </div>
    </div>
  );
};

export default Barcode;
